import React, { useContext } from "react";

import "../../styles/border.css";
import "../../styles/screens/general.scss";

const Border = () => {
  const borderSrc = "/images/borders/topLeftCorner.png"

  return (
    <div className="uiBorders">
      <img src={borderSrc} alt="border" className="uiBordersItem uiBordersItem1"></img>
      <img src={borderSrc} alt="border" className="uiBordersItem uiBordersItem2"></img>
      <img src={borderSrc} alt="border" className="uiBordersItem uiBordersItem3"></img>
      <img src={borderSrc} alt="border" className="uiBordersItem uiBordersItem4"></img>
    </div>
  );
};

export default Border;
